module.exports=[
  {
    "story": "Why did it take that much?",
    "name": "Adam Vu",
    "age": 14,
    "location": "Denver, Colorado",
    "type": "photo",
    "file_name": "",
    "headshot_name": "adam-vu"
  },
  {
    "story": "We deserve to live without fear.",
    "name": "Helen Chen",
    "age": 17,
    "location": "Brooklyn, New York",
    "type": "basic"
  },
  {
    "story": "Teaming up, we can stop racism.",
    "name": "Quentin Tai Murphy",
    "age": 9,
    "location": "Denver, Colorado",
    "type": "basic"
  },
  {
    "story": "We matter today, tomorrow, and forever.",
    "name": "Iqra Hashmi",
    "age": 18,
    "location": "Gilbert, Arizona",
    "type": "basic"
  },
  {
    "story": "Anti-Asian racism overwhelmed me this year. So I started speaking out.",
    "name": "William Diep",
    "age": 17,
    "location": "Queens, New York",
    "type": "first-person",
    "file_name": "",
    "headshot_name": "william-diep",
    "url": "https://ny.chalkbeat.org/2021/4/13/22380375/virus-racism-against-asian-americans-young-people",
    "button_language": "Read his story"
  },
  {
    "story": "I am proud to be Asian.",
    "name": "Logan Tai Murphy",
    "age": 8,
    "location": "Denver, Colorado",
    "type": "basic"
  },
  {
    "story": "I feel both lucky and scared.",
    "name": "Ione Anglin",
    "age": 8,
    "location": "Brooklyn, New York",
    "type": "basic"
  },
  {
    "story": "Equality matters. No matter what race.",
    "name": "Angelikah Pollante",
    "age": 15,
    "location": "Staten Island, New York",
    "type": "photo",
    "file_name": "",
    "headshot_name": "angelikah-pollante"
  },
  {
    "story": "Where do I, an adoptee, belong?",
    "name": "Ella Catlin",
    "age": 18,
    "location": "Indianapolis, Indiana",
    "type": "basic"
  },
  {
    "story": "Seeking unity requires truth and mercy.",
    "name": "Erin Donlon",
    "age": 22,
    "location": "Memphis, Tennessee",
    "type": "photo",
    "file_name": "",
    "headshot_name": "erin-donlon"
  },
  {
    "story": "I’m Asian American and I’m unique.",
    "name": "Lulu X.",
    "age": 13,
    "location": "New York, New York",
    "type": "basic"
  },
  {
    "story": "Surrounded with support yet tokenized, still.",
    "name": "Katherine Riley",
    "age": 29,
    "location": "Philadelphia, Pennsylvania",
    "type": "basic"
  },
  {
    "story": "",
    "name": "Kelly Shi",
    "age": 15,
    "location": "Queens, New York",
    "type": "art",
    "file_name": "kelly-shi",
    "headshot_name": "",
    "url": "",
    "button_language": "View art"
  },
  {
    "story": "Belonging is a feeling few have.",
    "name": "Kourtney Rathke",
    "age": 15,
    "location": "Boulder, Colorado",
    "type": "photo",
    "file_name": "",
    "headshot_name": "kourtney-rathke"
  },
  {
    "story": "Take up space no matter what.",
    "name": "Josette Candelaria",
    "age": 15,
    "location": "San Diego, California",
    "type": "photo",
    "file_name": "",
    "headshot_name": "josette-candelaria"
  },
  {
    "story": "Feel like a volcano, exploding rage.",
    "name": "Tommy Lu",
    "age": 18,
    "location": "Queens, New York",
    "type": "basic"
  },
  {
    "story": "I'm increasingly aware of our invisibility.",
    "name": "Amy Zhai",
    "age": 18,
    "location": "Potomac, Maryland",
    "type": "basic"
  },
  {
    "story": "How long until the killing stops?",
    "name": "Alexandra Yao",
    "age": 9,
    "location": "Denver, Colorado",
    "type": "video",
    "file_name": "",
    "headshot_name": "",
    "url": "https://www.youtube.com/embed/45RFSRo9zqE?modestbranding=1?rel=0"
  },
  {
    "story": "proud and happy and scared, too.",
    "name": "Arrow Anglin",
    "age": 6,
    "location": "Brooklyn, New York",
    "type": "basic"
  },
  {
    "story": "Silenced from voicing our racial pain.",
    "name": "Megan Nguyen",
    "age": 21,
    "location": "Berkeley, California",
    "type": "photo",
    "file_name": "",
    "headshot_name": "megan-nguyen"
  },
  {
    "story": "This is America.  Everyone is equal.",
    "name": "Aidan Kuo",
    "age": 14,
    "location": "New York, New York",
    "type": "basic"
  },
  {
    "story": "Stop saying wish, start saying will.",
    "name": "Lilly Schlesinger",
    "age": 11,
    "location": "Denver, Colorado",
    "type": "photo",
    "file_name": "",
    "headshot_name": "lilly-schlesinger"
  },
  {
    "story": "I am Asian, yet also American.",
    "name": "Carter Kuo",
    "age": 10,
    "location": "New York, New York",
    "type": "basic"
  },
  {
    "story": "Why am I so terribly different?",
    "name": "Ira Sharma",
    "age": 15,
    "location": "Memphis, Tennessee",
    "type": "basic"
  },
  {
    "story": "",
    "name": "Aidan (Aiko) Reidy",
    "age": 18,
    "location": "Denver, Colorado",
    "type": "art",
    "file_name": "aidan-reidy-1",
    "headshot_name": "",
    "url": "",
    "button_language": "View art"
  },
  {
    "story": "We are all different but human.",
    "name": "Rony Velasco",
    "age": 15,
    "location": "Flushing, Queens, New York",
    "type": "basic"
  },
  {
    "story": "Please stop all the hate crimes.",
    "name": "Yuhao Gao",
    "age": 18,
    "location": "Flushing, Queens, New York",
    "type": "basic"
  },
  {
    "story": "I need you to be uncomfortable.",
    "name": "Kayla Park",
    "age": 17,
    "location": "Washington, D.C.",
    "type": "basic"
  },
  {
    "story": "I didn’t learn about Asian American history in high school. We can’t fail another generation of students.",
    "name": "Kayla Huynh",
    "age": "",
    "location": "Normal, Illinois",
    "type": "first-person",
    "file_name": "",
    "headshot_name": "kayla-huynh",
    "url": "https://chicago.chalkbeat.org/2021/3/31/22357156/asian-american-history-high-school",
    "button_language": "Read her story"
  },
  {
    "story": "I am Asian; I am strong.",
    "name": "Sienna Stedman",
    "age": 11,
    "location": "New York, New York",
    "type": "basic"
  },
  {
    "story": "Aren't we all people without definition?",
    "name": "Karol Guallpa",
    "age": 13,
    "location": "Corona, Queens, New York",
    "type": "basic"
  },
  {
    "story": "We are not your model minority.",
    "name": "Aidan (Aiko) Reidy",
    "age": 18,
    "location": "Denver, Colorado",
    "type": "photo",
    "file_name": "",
    "headshot_name": "aidan-reidy"
  },
  {
    "story": "Reflecting on choosing to blend in.",
    "name": "Alexander Jue",
    "age": 32,
    "location": "Washington, D.C.",
    "type": "basic"
  },
  {
    "story": "Nobody can fight, but peace can.",
    "name": "Beatrice Yang",
    "age": 9,
    "location": "Englewood, Colorado",
    "type": "basic"
  },
  {
    "story": "You must stop discriminating against Asians.",
    "name": "Yuxin Gong",
    "age": 15,
    "location": "Flushing, Queens, New York",
    "type": "basic"
  },
  {
    "story": "Comfort the disturbed; disturb the comfortable.",
    "name": "Aly Moosa",
    "age": 17,
    "location": "Colleyville, Texas",
    "type": "photo",
    "file_name": "",
    "headshot_name": "aly-moosa"
  },
  {
    "story": "",
    "name": "Aly Moosa",
    "age": 17,
    "location": "Colleyville, Texas",
    "type": "video",
    "file_name": "",
    "headshot_name": "aly-moosa",
    "url": "https://www.youtube.com/embed/x2HOM7vzDjo?modestbranding=1?rel=0"
  },
  {
    "story": "We are all the same, stop!",
    "name": "Angel Peña",
    "age": 14,
    "location": "Jamaica, Queens, New York",
    "type": "basic"
  },
  {
    "story": "Asian American Pacific Islanders deserve rights.",
    "name": "Dean Chen-Becker",
    "age": 12,
    "location": "Greenwood Village, Colorado",
    "type": "basic"
  },
  {
    "story": "Where is oppression, there is resistance.",
    "name": "Longyu Lin",
    "age": 17,
    "location": "New York, New York",
    "type": "basic"
  },
  {
    "story": "Suffering but surrounded by performative activists.",
    "name": "Maeve Reidy",
    "age": 15,
    "location": "Denver, Colorado",
    "type": "photo",
    "file_name": "",
    "headshot_name": "maeve-reidy"
  },
  {
    "story": "Discrimination, inequality and unfairness are meaningless.",
    "name": "Tom Fang",
    "age": 15,
    "location": "Queens, New York",
    "type": "basic"
  },
  {
    "story": "Why fit in? Stand out instead.",
    "name": "Kelly Shi",
    "age": 15,
    "location": "Queens, New York",
    "type": "photo",
    "file_name": "",
    "headshot_name": "kelly-shi"
  },
  {
    "story": "We are all in this together.",
    "name": "Fernando Zavala",
    "age": 15,
    "location": "Flushing, Queens, New York",
    "type": "basic"
  },
  {
    "story": "Society, racism, hate, never ending cycle",
    "name": "Karen Mendez",
    "age": 18,
    "location": "Staten Island, New York",
    "type": "basic"
  },
  {
    "story": "",
    "name": "Aidan (Aiko) Reidy",
    "age": 18,
    "location": "Denver, Colorado",
    "type": "art",
    "file_name": "aidan-reidy-2",
    "headshot_name": "",
    "url": "",
    "button_language": "View art"
  },
  {
    "story": "Asian Americans have it much harder.",
    "name": "Daniel Nguyen",
    "age": 33,
    "location": "Sacramento, California",
    "type": "basic"
  },
  {
    "story": "Respect and love is the key.",
    "name": "Julio Illicachi",
    "age": 14,
    "location": "Queens, New York",
    "type": "basic"
  },
  {
    "story": "Violence, violence, exclusion, hate, supression, invisible",
    "name": "Jason L.",
    "age": 22,
    "location": "Oakland, California",
    "type": "basic"
  },
  {
    "story": "We are only seen as Chinese.",
    "name": "Sun-Jin Shah",
    "age": 13,
    "location": "DeWitt, New York",
    "type": "photo",
    "file_name": "",
    "headshot_name": "sun-jin-shah"
  },
  {
    "story": "Don't be afraid to stand out.",
    "name": "Dahlia Chen-Becker",
    "age": 9,
    "location": "Greenwood Village, Colorado",
    "type": "basic"
  },
  {
    "story": "Hate crime more dangerous than COVID!",
    "name": "Woiser Youdon",
    "age": 23,
    "location": "Jackson Heights, Queens, New York",
    "type": "photo",
    "file_name": "",
    "headshot_name": "woiser-youdon"
  },
  {
    "story": "How long until the killing stops?",
    "name": "Alexandra Yao",
    "age": 9,
    "location": "Denver, Colorado",
    "type": "photo",
    "file_name": "",
    "headshot_name": "alexandra-yao"
  },
  {
    "story": "I am very scared about this.",
    "name": "Sazedul Islam",
    "age": 17,
    "location": "New York, New York",
    "type": "basic"
  },
  {
    "story": "Stop the hate, love each other.",
    "name": "Elise Yang",
    "age": 11,
    "location": "Denver, Colorado",
    "type": "basic"
  },
  {
    "story": "How scared and terrified, a victim.",
    "name": "Jiaci",
    "age": 17,
    "location": "New York, New York",
    "type": "basic"
  },
  {
    "story": "I am proud to be Asian.",
    "name": "Dylan Chen-Becker",
    "age": 14,
    "location": "Greenwood Village, Colorado",
    "type": "basic"
  },
  {
    "story": "No to racism against Asian people.",
    "name": "Dylan Fabre",
    "age": 16,
    "location": "Queens, New York",
    "type": "basic"
  },
  {
    "story": "Everyone is equal",
    "name": "Changsheng Zhao",
    "age": 16,
    "location": "Flushing, Queens, New York",
    "type": "basic"
  }
]